<label class="normal-checkbox-container {{error.errorCss}}">
  <input type="checkbox" id="chkPrivacy" name="politica" [(ngModel)]="isChecked" (change)="submitAnswer()">
  <div class="checkmark-container">
    <span class="checkmark"></span>
    <span class="text-09-m-regular text-13-d-regular">
      He leído y acepto el
      <a href="https://www.rastreator.com/aviso-legal.aspx" target="_blank" class="white-bg">aviso legal</a>,
      <a href="https://www.rastreator.com/doc/informacion-previa-del-mediador.pdf" target="_blank" class="white-bg">info
        previa</a>, la
      <a href="https://www.rastreator.com/politica-de-privacidad.aspx" target="_blank" class="white-bg">política de
        privacidad</a>
      y reconozco que la información legal previa está disponible en la web.
    </span>
  </div>
    <p class="error" id="error-privacy" *ngIf="error.isInValid">Para continuar, acepta el aviso legal, info previa, la política
    de privacidad y reconoce que la información legal previa está disponible en la web</p>
  <div class="email-legal-text">
    <p>También puedes recibir esta información en papel, contactando con nosotros en
      clientes@rastreator.com</p>
  </div>
  <div class="phone-legal-text" *ngIf="(telephoneValidationService.isPhoneEmpty$ | async) === false">
    <p>Para ayudarte es posible que te contactemos por teléfono de lunes a viernes de 9:00 a 20:30h y sábados de 9:00 a
      15:00h.</p>
  </div>
</label>